import {
  GET_RETAIL_PLAN_INPUTS,
  GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA,
} from './constants';

export const getRetailPlanInputs = () => ({
  type: GET_RETAIL_PLAN_INPUTS,
});

export const fetchRetailProductionPlanTabMetadata = () => ({
  type: GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA,
});
